export interface IMessageNotiticationDataModel {
    Id: number;
    Subject: string;
    Content: string;
    UserId: number;
    Category: string;
    ModuleInfo: object;
}
export interface INotificationItemModel<TPayload> {
    type: string;
    payloadData: TPayload;
    contentMessage?: any;
    provider?: string;
}

export class NotificationItemModel<TPayload> implements INotificationItemModel<TPayload> {
    type: string;
    payloadData: TPayload;
    contentMessage?: any;
    provider?: string;
    constructor(props: INotificationItemModel<TPayload>) {
        Object.assign(this, props);
    }
}